export const get_exchange_order = `query get_exchange_order($id: Int!){
    get_exchange_order(id: $id){
        id
        transaction_code
        status
        direction
        account
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        count
        fulfilled_count
        daytrade
        daytrade_type
        type
        limit_price
        activation_price
        outside_trading_hours
        validity_start
        validity_end
        deal_price
        reject_reason
        reject_reason_en
        cancel_accepted
        cancel_reject_reason
        cancel_reject_reason_en
    }
}`;
